<template>
  <div class="row mt-2">
    <template v-for="event in evenements">
      <b-form-group
        v-if="event.type !== 'ACTE_VENTE'"
        :label="$t(event.label)"
        :label-for="event.type + '-input'"
        class="col-md-6 medium-label mb-4">
        <datepicker-input
          :id="event.type + '-input'"
          v-model="event.date"
          locale="fr"
          v-on:input="emitChangeValue"
        >
        </datepicker-input>
      </b-form-group>
      <div v-else class="col-md-6">
        <div class="row justify-content-between px-3 pb-2 medium-text">
          <div> {{ $t(event.label) }}</div>
          <div class="row px-2">
            <span class="mr-2"> {{ $t('evenementPlanning.date.reelle') }} </span>
            <b-form-checkbox
              v-model="event.realDate"
              v-on:change="emitChangeValue">
            </b-form-checkbox>
          </div>
        </div>
        <datepicker-input
          :id="event.type + '-input'"
          v-model="event.date"
          locale="fr"
          v-on:input="emitChangeValue"
        >
        </datepicker-input>
      </div>
    </template>
  </div>
</template>

<script>
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";

export default {
  name: "EvenementCreateEditOperationLot",

  components: {
    DatepickerInput
  },

  emits: ['didChangeValue'],

  props: {
    evenements: Object
  },

  methods: {
    async emitChangeValue() {
      this.$emit('didChangeValue')
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationPlanning/EvenementCreateEditOperationLot.vue